import * as React from 'react';
import { equals, reject } from 'ramda';
import { styled } from 'styled-components';
import type { CheckedChangeEvent } from '@sunwebgroup/ui-components';
import { Checkbox, SpaceBetween, tk } from '@sunwebgroup/ui-components';
import type { Options } from './Shared';

interface FilterProps {
  options: Options[];
  selectedValues: string[];
  onSelectedValueChange: (newSelectedValue: string[]) => void;
}

export function Root({ options, selectedValues, onSelectedValueChange }: FilterProps) {
  function handleCheckedChange({ checked, value }: CheckedChangeEvent) {
    if (checked) {
      onSelectedValueChange([...selectedValues, String(value)]);
    }

    if (!checked) {
      onSelectedValueChange(reject(equals(value), selectedValues));
    }
  }

  return (
    <Content direction="y" spacing={tk('spacing_lg')}>
      {options.map((option, index) => (
        <Checkbox
          key={index}
          label={option.name}
          name={option.name}
          value={option.value}
          onCheckedChange={handleCheckedChange}
          defaultChecked={selectedValues.includes(option.value)}
        />
      ))}
    </Content>
  );
}

export const Content = styled(SpaceBetween)`
  padding: ${tk('spacing_lg')} ${tk('spacing_lg')} 0;
`;

export const Footer = styled.div`
  background-color: ${tk('color_semantic_bg')};
  bottom: 0;
  display: flex;
  padding: ${tk('spacing_xs')} ${tk('spacing_lg')} ${tk('spacing_lg')};
  position: -webkit-sticky;
  position: sticky;
  width: 100%;
  z-index: 1;
`;
